/**
 * booking-sheet-hold: the rules that keep the booking sheet's hold and its picked time together
 * (CC 0366, 0368). Pure, so each rule is tested on its own.
 */
export type SlotLike = { start: string; end: string; staffId?: string | null };
export type HeldFor = { holdId: string; key: string };

/** One picked time as a key that survives a slot-list reload (the slot objects are rebuilt). The sheet
 *  adds "#<generation>" per pick so a request from an earlier pick of the same time never matches. */
export function slotKey(date: string, s: SlotLike | null | undefined): string {
  return s ? [date, s.start, s.end, s.staffId || ""].join("|") : "";
}

/** A hold answer is used only if it is for the time picked now; anything else is released.
 *  A closed sheet has no pick (its key is ""), so every answer that lands after close is released. */
export function holdIsForPick(requestKey: string, currentKey: string): boolean {
  return !!requestKey && requestKey === currentKey;
}

/** Confirm needs a hold for exactly the time on screen. */
export function holdMatchesPick(hold: HeldFor | null, currentKey: string): boolean {
  return !!hold && !!currentKey && hold.key === currentKey;
}

/** The create's refusals that mean the hold is gone: clear it and re-pick. */
export function holdIsGone(code: string | null | undefined): boolean {
  return code === "HOLD_EXPIRED" || code === "HOLD_INVALID";
}

export type SaveChecks = {
  hasService: boolean; hasPick: boolean; pickStillOffered: boolean; hasZone: boolean;
  nameOk: boolean; gateBlocked: boolean; saving: boolean; holding: boolean; holdMatches: boolean;
  busyRefusal: boolean;
};

/** Every check a booking needs. "Book anyway" (ack) waives ONLY the busy refusal. */
export function canBook(c: SaveChecks, ack: boolean): boolean {
  const base = c.hasService && c.hasPick && c.pickStillOffered && c.hasZone && c.nameOk && !c.gateBlocked
    && !c.saving && !c.holding && c.holdMatches;
  return base && (ack || !c.busyRefusal);
}
